<div class="gallery-area overflow-hidden w-100 my-2 my-lg-5">
    <div class="container th-container my-2 my-lg-5">
        <div class="title-area text-center">
            <span class="sub-title mb-15 text-anime-style-2">Our Gallery</span>
            <h2 class="sec-title text-anime-style-3">Our Recent Project Gallery</h2>
        </div>
        <div class="row gy-10 gx-10 justify-content-center align-items-center">
            <div class="col-md-6 col-lg-2">
                <div class="gallery-card">
                    <div class="box-img global-img">
                        <a href="assets/img/gallery/gallery_1_1.jpg" class="popup-image">
                            <div class="icon-btn"><i class="fal fa-magnifying-glass-plus"></i></div>
                            <img src="assets/img/gallery/gallery_1_1.jpg" alt="gallery image">
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-2">
                <div class="gallery-card">
                    <div class="box-img global-img">
                        <a href="assets/img/gallery/gallery_1_2.jpg" class="popup-image">
                            <div class="icon-btn"><i class="fal fa-magnifying-glass-plus"></i></div>
                            <img src="assets/img/gallery/gallery_1_2.jpg" alt="gallery image">
                        </a>
                    </div>
                </div>
                <div class="gallery-card">
                    <div class="box-img global-img">
                        <a href="assets/img/gallery/gallery_1_3.jpg" class="popup-image">
                            <div class="icon-btn"><i class="fal fa-magnifying-glass-plus"></i></div>
                            <img src="assets/img/gallery/gallery_1_3.jpg" alt="gallery image">
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-2">
                <div class="gallery-card">
                    <div class="box-img global-img">
                        <a href="assets/img/gallery/gallery_1_4.jpg" class="popup-image">
                            <div class="icon-btn"><i class="fal fa-magnifying-glass-plus"></i></div>
                            <img src="assets/img/gallery/gallery_1_4.jpg" alt="gallery image">
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-2">
                <div class="gallery-card">
                    <div class="box-img global-img">
                        <a href="assets/img/gallery/gallery_1_5.jpg" class="popup-image">
                            <div class="icon-btn"><i class="fal fa-magnifying-glass-plus"></i></div>
                            <img src="assets/img/gallery/gallery_1_5.jpg" alt="gallery image">
                        </a>
                    </div>
                </div>
                <div class="gallery-card">
                    <div class="box-img global-img">
                        <a href="assets/img/gallery/gallery_1_6.jpg" class="popup-image">
                            <div class="icon-btn"><i class="fal fa-magnifying-glass-plus"></i></div>
                            <img src="assets/img/gallery/gallery_1_6.jpg" alt="gallery image">
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-2">
                <div class="gallery-card">
                    <div class="box-img global-img">
                        <a href="assets/img/gallery/gallery_1_7.jpg" class="popup-image">
                            <div class="icon-btn"><i class="fal fa-magnifying-glass-plus"></i></div>
                            <img src="assets/img/gallery/gallery_1_7.jpg" alt="gallery image">
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="shape-mockup th-line-shape d-none d-xl-block" data-top="-18%" data-left="0">
            <span>
                <svg width="3200" height="860" viewBox="0 0 3200 860" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path class="line-1"
                        d="M2138 14.0506C2095.27 -17.4415 2002.06 10.9842 1886.26 120.726C1741.5 257.904 1351.09 392.927 1300.98 262.785C1236.52 95.3792 1538.14 78.636 1447.87 346.052C1357.6 613.468 810.026 408.273 376.356 511.519C46.7827 589.983 -27.4648 825.017 -14.6451 859"
                        stroke="currentColor" stroke-width="4" />
                </svg>
            </span>
        </div>
        <div class="shape-mockup movingX d-none d-xl-block" data-top="11%" data-left="-3%">
            <img class="gmovingX" src="assets/img/shape/g-shape-1.png" alt="shape">
        </div>
        <div class="shape-mockup jump d-none d-xl-block" data-bottom="0" data-right="-3%">
            <img class="gmovingX" src="assets/img/shape/ab-1-shape-2.png" alt="shape">
        </div>
    </div>
</div>